import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Brand";
import { Footer } from "@/components/Footer";

// Panel visual de la derecha: prueba real de la interfaz sobre acento suave.
function ProductProof() {
    return (
        <div className="relative hidden overflow-hidden bg-nm-panel lg:block">
            <div
                className="absolute inset-0 grain opacity-60"
                style={{ background: "radial-gradient(120% 120% at 20% 0%, #8b5cf6 0%, #0b0912 60%)" }}
            />
            <div className="relative flex h-full flex-col justify-center px-14">
                <p className="text-sm font-medium uppercase tracking-wider text-white/60">Tu sistema de captación</p>
                <h2 className="mt-4 max-w-sm text-3xl font-bold leading-tight tracking-tight text-white">
                    Cada mañana sabes exactamente qué hacer.
                </h2>
                <div className="mt-10 max-w-sm space-y-3">
                    <div className="rounded-2xl border border-white/10 bg-nm-surface/95 p-4 shadow-sm">
                        <p className="text-xs font-medium uppercase tracking-wider text-nm-muted">Acciones de hoy</p>
                        <div className="mt-3 space-y-3">
                            {[
                                ["Marta Giménez", "Hacer seguimiento"],
                                ["Nuria Belmonte", "Invitar a la presentación"],
                                ["Carlos Ferrán", "Enviar el primer mensaje"],
                            ].map(([n, a]) => (
                                <div key={n} className="flex items-center gap-3">
                                    <span className="grid h-8 w-8 place-items-center rounded-full bg-nm-accent text-xs font-semibold text-white">
                                        {n.split(" ").map((x) => x[0]).join("")}
                                    </span>
                                    <div>
                                        <p className="text-sm font-semibold text-nm-ink">{n}</p>
                                        <p className="text-xs text-nm-muted">{a}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function AuthShell({ title, subtitle, children, footer }) {
    return (
        <div className="min-h-screen bg-nm-bg">
            <div className="grid min-h-screen lg:grid-cols-2">
                <div className="flex flex-col px-6 py-8 sm:px-10">
                    <Link to="/" data-testid="auth-logo-home">
                        <Wordmark />
                    </Link>
                    <div className="flex flex-1 items-center">
                        <div className="mx-auto w-full max-w-sm py-10">
                            <h1 className="text-3xl font-bold tracking-tight text-nm-ink">{title}</h1>
                            {subtitle && <p className="mt-2 text-nm-muted">{subtitle}</p>}
                            <div className="mt-8">{children}</div>
                            {footer && <div className="mt-6 text-sm text-nm-muted">{footer}</div>}
                        </div>
                    </div>
                    <div className="text-xs text-nm-muted">Network Mastery · +34 694 406 037</div>
                </div>
                <ProductProof />
            </div>
        </div>
    );
}

export { Footer };
